import FormHelpers from './util/formErrors';
import Callout from './components/callout';

class GiftCard {
  constructor(){
    this.form = $(".gift-card-form");
    this.spinnerWrapper = $('.loading-wrapper');
    this.amountSelector = $('.js-amount-selector', this.form);
    this.datePicker = $('.js-date-picker', this.form);
    this.amountInputContainer = $('.js-amount-input-field', this.amountSelector)
    this.amountInput = $('#giftCardAmount', this.amountInputContainer);
    this.dateInput = (".js-date-format", this.form);
    this.hourInput = (".js-hour-format", this.form);
    this.paymentErrorWrapper = $(".coupon-error-wrapper");
    this.modalWrapper = $('.modal-background');

    this.verifyPage = $('.gift-card-verify-page');
    this.firstAlertTemplate = $($("template#gift-card-first-alert-template").prop("content"));
    this.secondAlertTemplate = $($("template#gift-card-second-alert-template").prop("content"));
    this.verifyTemplate = $($("template#gift-card-verify-template").prop("content"));
    this.initialize();
  }

  initialize() {
    this.form.ready(() => {

      this.initializeFirstModalAlert();
      this.initializeFormattedInput();
      this.initializeAmountSelector();
      this.initializeDatePicker();
      this.messageCharCounter();
      this.showMore();

      this.amountInput.parsley({
        errorClass: 'is-invalid-input',
        successClass: 'is-valid-input',
        errorsWrapper: '<div class="errors-list"></div>',
        errorTemplate: '<span class="form-error is-visible"></span>',
        errorsContainer: this.amountSelector
      })

      this.form.submit((e) => this.submitPurchaseGiftCard(e, false));
    });

    this.verifyPage.ready(() => {
      $('.gift-card-verify-form', this.verifyPage).submit((e) => this.handleVerifyCode(e));
    });
  }

  submitPurchaseGiftCard(e, destroyBasket) {
    e.preventDefault();

    FormHelpers.clearPreviousErrors(this.form);
    const shippingFormData = this.form.serialize();
    this.toggleSpinner();

    $.ajax({
      url: this.form.attr('action'),
      method: this.form.attr("method"),
      data: shippingFormData + `&destroyBasket=${!!destroyBasket}`,
      success: (data) => {
        if (!data.error) {
          this.pushDataLayer(data.order);
          window.location = data.continueUrl;
        } else {
          this.toggleSpinner();
          if(data.hasProductError){
            this.initializeSecondModalAlert();
          } else {
            FormHelpers.loadFormErrors(this.form, data.formErrors, false);
          }
        }
      },
      error: (err) => {
        this.toggleSpinner();
        if (!!err && !!err.responseJSON && !!err.responseJSON.message)
          Callout.error("", err.responseJSON.message, this.paymentErrorWrapper)
      }
    });
  }

  initializeFormattedInput() {

    if(this.dateInput.length)
      this.cleave = new Cleave(this.dateInput, {
        date: true,
        delimiter: '/',
        datePattern: ['d', 'm', 'Y']
      });

    if(!!this.hourInput.length)
      this.cleave = new Cleave(this.hourInput, {
        time: true,
        timePattern: ['h', 'm']
      });
  }

  initializeAmountSelector() {
    $('button.js-select-amount', this.amountSelector).click((e) => {
      e.preventDefault();
      $('button.js-select-amount', this.amountSelector).removeClass('active');
      const btn = $(e.target);
      btn.addClass('active');
      let value = Number(btn.val());
      this.amountInput.val(value === 0 ? '' : value);
      this.amountInput.siblings(".suffix").toggle(false);
      this.amountInputContainer.toggle(btn.val() === '');
      this.amountInput.parsley().reset();
    });

    this.amountInput.on('keypress', (e) => {
      if (!e.which || e.which < 48 || e.which > 57)
        e.preventDefault();
    })

    this.amountInput.on('textInput', (e) => {
      let keyCode = e.originalEvent.data.charCodeAt(0);
      if (keyCode < 48 || keyCode > 57)
        e.preventDefault();
    })

    this.amountInput.on('input', (e) => {
      const target = $(e.target);
      const widthCalculator = target.siblings(".width-calculator")
      const value = target.val();
      const suffix = target.siblings(".suffix")
      if(value === ''){
        suffix.toggle(false);
      } else {
        suffix.toggle(true);
        widthCalculator.text(value);
        const offset = widthCalculator.width();
        suffix.css("padding-left", parseInt(suffix.css("padding-right"))+offset);
      }
    });

    if(this.amountInput.val() !== ''){
      const selectedAmount = this.amountSelector.find(`button[value="${this.amountInput.val()}"]`);
      if(selectedAmount.length > 0) {
        selectedAmount.click()
      } else {
        const amount = parseInt(this.amountInput.val());
        this.amountSelector.find('button.js-select-amount').click();
        this.amountInput.val(amount).trigger('input');
      }
    }
  }

  initializeDatePicker() {
    const today = new Date();
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate()+30);

    let selectedFormatted = $('#date', this.datePicker).val()
    let selected = null;
    if(!!selectedFormatted){
      const [day, month, year] = selectedFormatted.split("/");
      selected = new Date(year, month-1, day);
    }

    this.picker = new easepick.create({
      element: $('#date', this.datePicker).get(0),
      css: [
        'https://cdn.jsdelivr.net/npm/@easepick/core@1.2.0/dist/index.css',
        'https://cdn.jsdelivr.net/npm/@easepick/lock-plugin@1.2.0/dist/index.css',
        this.datePicker.data('style')
      ],
      format: "DD/MM/YYYY",
      calendars: 2,
      grid: 2,
      inline: true,
      lang: `${$('html').attr("lang")}-${$('body').data("country")}`,
      plugins: ['LockPlugin'],
      LockPlugin: {
        minDate: today,
        maxDate: maxDate
      },
      autoApply: true,
      date: selected ? selected.getTime() : null,
      setup(picker) {
        picker.on('select', (e) => {
          const { date } = e.detail;
          $('.easepick-wrapper', this.datePicker).hide();
          $('.js-pick-date', this.datePicker).text(date.toLocaleDateString(
            `${$('html').attr("lang")}-${$('body').data("country")}`,
            {day: "numeric", month: "long", year: "numeric"}
          ));
        });
      },
    });

    if($('#date', this.datePicker).val() !== ''){
      const [day, month, year] = $('#date', this.datePicker).val().split("/");
      const date = new Date(year, month-1, day);
      $('.js-pick-date', this.datePicker).text(date.toLocaleDateString($('body').data('country').toLowerCase(),
        {day: "numeric", month: "long", year: "numeric"})
      );
    }

    $('button', this.datePicker).click((e) => {
      e.preventDefault();
      $('button', this.datePicker).removeClass('active');
      const btn = $(e.target);
      btn.addClass('active');
      if(btn.hasClass('js-pick-date')) {
        $('.easepick-wrapper', this.datePicker).show();
      }
      else if(btn.hasClass('js-date-now')) {
        $('.easepick-wrapper', this.datePicker).hide();
        const pickDateBtn = $('.js-pick-date', this.datePicker);
        pickDateBtn.text(pickDateBtn.data('label'));
        $('#date', this.datePicker).val("");
      }
    });
  }

  initializeFirstModalAlert() {
    if(!this.form.data('active')) {
      this.form.one('click', (e) => {
        e.preventDefault();
        this.firstAlertTemplate.clone().appendTo(this.modalWrapper);
        this.modalWrapper.css('display', 'flex');
        this.modalWrapper.find('button').click((e) => this.closeModal(e));
        $(e.target).blur();
      });
    }
  }

  initializeSecondModalAlert() {
    this.secondAlertTemplate.clone().appendTo(this.modalWrapper);
    this.modalWrapper.css('display', 'flex');
    this.modalWrapper.find('button.js-continue-btn').click((e) => {
      this.closeModal(e);
      this.submitPurchaseGiftCard(e, true);
    });
    this.modalWrapper.find('button.js-not-continue-btn').click((e) => {
      e.preventDefault();
      window.location = $(e.target).data('action');
    })
  }

  closeModal(e) {
    e.preventDefault();
    this.modalWrapper.empty();
    this.modalWrapper.hide();
  }

  addVerifyForm() {
    const newVerifyTemplate = this.verifyTemplate.clone();
    $('.gift-card-verify-form', newVerifyTemplate).submit((e) => this.handleVerifyCode(e));
    $('.add-verify-btn', newVerifyTemplate).click((e) => {
      const target = $(e.target);
      target.attr('data-action') === '+' ? target.attr('data-action', '-') : target.attr('data-action', '+');
      target.siblings('.first-step').toggle();
    });
    this.verifyPage.append(newVerifyTemplate);
  }

  handleVerifyCode(e) {
    e.preventDefault();
    const target = $(e.target);
    const useGift = target.find('input[name$="addToPaymentInstrument"]').val() === "true";
    grecaptcha.ready(() => {
      grecaptcha.execute(this.verifyPage.data('recaptchaKey'), {action: 'submit'}).then((token) => {
        $.ajax({
          url: target.attr('action'),
          method: target.attr('method'),
          data: target.serialize() + '&recaptchaToken=' + token,
          success: response => {
            const wrapper = target.closest('.gift-card-verify-wrapper')
            if (!!useGift) {
              const secondStepBtn = wrapper.find('.second-step .js-gift-card-verify-btn')
              secondStepBtn.find('span').text(secondStepBtn.data('usedLabel'));
              secondStepBtn.find('svg').removeClass('hidden');
              secondStepBtn.prop('disabled', true);
            } else {
              this.updateCodeSummary(wrapper, response.couponStatus);
              this.addVerifyForm();
            }
          },
          error: error => {
            if (useGift && error.responseJSON.couponStatus.error) {
              const wrapper = target.closest('.gift-card-verify-wrapper')
              Callout.error(
                null,
                error.responseJSON.couponStatus.errorMessage,
                wrapper.find('.second-step .error-wrapper'),
                false, false, false
              );
              wrapper.find('.second-step .js-gift-card-verify-btn').prop("disabled", true);
            } else if (!useGift && !error.responseJSON.couponStatus.isValid) {
              const wrapper = target.closest('.first-step');
              const input = wrapper.find('input[name$=giftCardCode]');
              input.parsley().removeError('error');
              input.parsley().addError('error', {
                message: error.responseJSON.couponStatus.errorMessage,
                updateClass: true
              });
              const span = wrapper.find('.parsley-errors-list');
              if(span.length > 0){
                span.addClass('form-error is-visible');
              }
            }
          }
        });
      });
    });
  }

  updateCodeSummary(wrapper, couponStatus) {
    wrapper.find('.first-step').remove();
    wrapper.find('.add-verify-btn').remove();
    const secondStep = wrapper.find('.second-step')
    secondStep.toggle(true);
    secondStep.find('.amount').text(secondStep.find('.amount').text().replace('{0}', couponStatus.couponCreditFormatted));
    secondStep.find('.code').text(secondStep.find('.code').text().replace('{0}', couponStatus.couponCode));
    secondStep.find('.expire').text(secondStep.find('.expire').text().replace('{0}', couponStatus.couponFormattedEndDate));
    secondStep.find('.message').html(secondStep.find('.message').html().replace('{0}', couponStatus.couponCreditFormatted));
    secondStep.find('input[name$=giftCardCode]').val(couponStatus.couponCode);
    if(!couponStatus.isValid) {
      if(['CouponLimitReached', 'CouponExpired'].includes(couponStatus.errorReason)) {
        secondStep.find('.info-box').empty().html(couponStatus.errorMessage);
        !!couponStatus.errorTitle && secondStep.find('.amount').empty().text(couponStatus.errorTitle);
      }
    }
  }

  toggleSpinner() {
    this.spinnerWrapper.toggleClass('loading');
  }

  messageCharCounter() {
    const emojisRegExp = /([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g;
    const counter = $('.subscript-message .left-char', this.form);
    $('#giftCardMessage', this.form).on('input', (e) => {
      const target = $(e.target);
      if(target.val().length > target.attr('maxlength')) {
        target.val(target.val().substring(0, target.attr('maxlength')));
      } else {
        const messageInput = $('#giftCardMessage', this.form);
        let max = Number(messageInput.attr('maxlength'));
        counter.text(max-messageInput.val().length);
        messageInput.val(messageInput.val().replace(/\n/g,"").replace(new RegExp(emojisRegExp), ''));
      }
    });

    $('#giftCardMessage', this.form).on('keypress', (e) => {
      if (e.which === 13)
        e.preventDefault();
    })

    $('#giftCardMessage', this.form).on('textInput', (e) => {
      let keyCode = e.originalEvent.data.charCodeAt(0);
      if (keyCode === 13)
        e.preventDefault();
    })

    $('#giftCardMessage', this.form).trigger('input');
  }

  showMore() {
    $('.show-more').click((e) => {
      const showMoreBtn = $('.show-more')
      if(!!showMoreBtn.data('toggleText')){
        $('.wrapped').toggle();
        let tempText = $('.show-more').data('toggleText');
        $('.show-more').data('toggleText', $('.show-more').text());
        $('.show-more').text(tempText);
      } else {
        $('.show-more').hide();
        $('.wrapped').show();
      }
    });
  }

  pushDataLayer(orderModel){
    let giftCard = orderModel.items.items[0];
    if(!giftCard) return;

    let analyticsObj = {
      event: "add_to_cart",
      ecommerce: {
        currency: orderModel.orderCurrencyCode,
        value: giftCard.price.sales.value,
        items: [{
          item_id: "GiftCard_" + giftCard.price.sales.value.toString(),
          item_name: giftCard.defaultProductName,
          currency: orderModel.orderCurrencyCode,
          item_brand: "Gift Card",
          item_category: "Gift Card",
          price: giftCard.price.sales.decimalPrice,
          quantity: 1
        }]
      }
    };
    dataLayer.push(analyticsObj);
  }
}

new GiftCard();


// WEBPACK FOOTER //
// ./assets/scripts/giftCard.js